import React from 'react';

/**
 * Honest announcement bar: no fake timers or counters, and never the price (Tomás, 23/10).
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="306k46ryezrb1">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-57" data-mp="2vd8umj27wwff">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-58" data-mp="2medp796zzqd6">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-59" data-mp="2mcapfxg1miv9" />
        </span>
        <span className="text-stone-50/80" data-id="element-60" data-mp="2hhdgsrmoebiw">
          <span className="hidden sm:inline" data-id="element-61" data-mp="2cfo7bgf3q5wx">Välitön digitaalinen lataus · Kertamaksu · 7 päivän tyytyväisyystakuu</span>
          <span className="sm:hidden" data-id="element-62" data-mp="28fxihi94xzv1">Välitön lataus · 7 päivän takuu</span>
        </span>
      </div>
    </div>;
}